module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_02_sp-30416103a55b46317a20b95d24e43962.png";